export const SET_CLICKED_PAGE = 'SET_CLICKED_PAGE'

export default {
  namespaced: true,
  state: {
    page: {},
  },
  getters: {},
  mutations: {
    [SET_CLICKED_PAGE](state, payload) {
      state.page = payload
    },
  },
  actions: {
    [SET_CLICKED_PAGE] ({ commit }, { menuItem }) {
      commit(SET_CLICKED_PAGE, menuItem)
    },
  },
}